<template>
  <div class="main" style="padding:0 66px">

    <div class="text-center">
      <div class="h6 main margin-top-12">결제정보를 확인하세요</div>
    </div>

    <!-- 결제 모듈 -->
    <div style="max-width:600px;margin:60px auto 0 auto">

      <div class="box-account margin-bottom-12">
        <div class="flex-between">
          <div class="body4-medium main">솔루션 {{ memberShip.name }}
            <span style="margin-left:2px">
              <template v-if="service && service.service_order.trial">
                ({{ dateUnitText }}{{ trial_product.month_free?'+1개월':'' }})
              </template>
              <template v-else>{{ dateUnitText }}</template>
            </span>
          </div>
          <div>
            <span class="body4-bold">{{ memberShipPrice | currencyNum }}</span>
            <span class="body4 sub">원</span>
            <span class="body4 sub3">/<template v-if="service && service.service_order.trial">{{ trial_product.month_free?`(${order_product.date_unit}+1)개월`:`${dateUnitText}` }}</template>
              <template v-else>{{ dateUnitText }}</template>
            </span>
          </div>
        </div>
        <div class="divider"></div>
        <div class="flex-between">
          <div class="body4-medium main">호스팅 {{ hosting.name }}
            <span style="margin-left:2px">
              <template v-if="service && service.service_order.trial">
                ({{ dateUnitText }}{{ trial_product.month_free?'+1개월':'' }})
              </template>
              <template v-else>{{ dateUnitText }}</template>
            </span>
          </div>
          <div>
            <span class="body4-bold">{{ hostingPrice | currencyNum }}</span>
            <span class="body4 sub">원</span>
            <span class=" sub3">/<template v-if="service && service.service_order.trial">{{ trial_product.month_free?`(${order_product.date_unit}+1)개월`:`${dateUnitText}` }}</template>
              <template v-else>{{ dateUnitText }}</template>
            </span>
          </div>
        </div>

        <template v-if="service && service.service_order.trial">
          <div class="divider"></div>
          <div class="flex-between">
            <div class="body4-medium main">추가 팩/플러그인</div>
            <div>
              <span class="body4-bold">{{ packPluginPrice | currencyNum }}</span>
              <span class="body4 sub">원</span>
            </div>
          </div>
        </template>

        <template v-if="trial_product.app_porting">
          <div class="divider"></div>
          <div class="flex-between">
            <div class="body4-medium main">앱포팅</div>
            <div>
              <span class="body4-bold">{{ trialPrice | currencyNum }}</span>
              <span class="body4 sub">원</span>
            </div>
          </div>
        </template>

        <!-- 무료 1개월 -->
        <!--<template v-if="trial_product.month_free">
          <div class="divider"></div>
          <div class="flex-between">
            <div class="body4-medium main">무료 1개월 이용권 추가</div>
            <div>
              <span class="body4-bold">{{ 0 | currencyNum }}</span>
              <span class="body4 sub">원</span>
            </div>
          </div>
        </template>-->

        <div class="divider"></div>
        <div class="flex-between">
          <div class="body4-medium main">부가세 (10%)</div>
          <div>
            <span class="body4-bold">{{ vat | currencyNum }}</span>
            <span class="body4 sub">원</span>
          </div>
        </div>

      </div>

      <div class="box-free" style="margin-top:12px">
        <div>
          <div class="subtitle6">총 결제 금액</div>
          <div style="font-weight:300;">(결제일/서비스이용시작일: {{ payday }})</div>
        </div>
        <div class="h6">{{ calcTotalPrice | currencyNum }}<span class="body2">원</span></div>
      </div>

      <ul style="margin-top:20px;padding:0 20px 0 28px" class="body5 sub2">
        <li style="list-style:disc">{{ payday }}에 결제가 시작되며 플랜주기별로 자동으로 갱신됩니다.</li>
        <li style="list-style:disc">결제일 이후 해지신청 시 다음 종료일에 해지됩니다.
          <a href="https://platformfy.com/term" target="_blank">취소 환불</a>에 관해 자세히 알아보기.
        </li>
        <li style="list-style:disc">모든 가격은 부가가치세를 제외한 것입니다. 계속 진행함으로써 본인이 만 19세 이상임을 확인하고,
          <a href="https://platformfy.com/term" target="_blank">본 약관</a>에 동의함을 확인합니다.
        </li>
        <li style="list-style:disc">
          계속 진행하면 런치팩 서비스 약관에 동의하는 것으로 간주됩니다.
          <a href="https://platformfy.com/privacy" target="_blank">개인정보처리방침</a> - 개인정보 수집 및 공유에 사용자의 데이터를 처리하는 방식이 설명되어 있습니다.
        </li>

        <li style="list-style:disc" v-if="trial_product.app_porting">앱포팅작업과 관련해서는 별도안내가 진행될 예정입니다.</li>
      </ul>

    </div>


    <div class="flex-center" style="margin-top:40px">
      <!--<button class="button is-primary body2-medium" style="width:368px;height:52px !important;"
              @click="clickNext" v-if="service && service.service_order.trial">다음</button>
      <div v-else>현재 무료이용기간에만 가능합니다.</div>-->
      <button class="button is-primary body2-medium" style="width:368px;height:52px !important;font-size:16px !important;"
              @click="clickNext">{{ buttonText }}
      </button>
    </div>

  </div>
</template>
<script>
  export default {
    name: "PlanChangeStep2",
    props: {
      service: {
        type: Object
      },
      hosting: {
        type: Object
      },
      order_product: {
        type: Object
      },
      selectorStocks: {
        type: Array
      },
      trial_product: {
        type: Object
      }
    },
    created() {
      this.getPlanChangePayDay();
    },
    data() {
      return {
        payday: '',
        enablePay: true
      }
    },
    computed: {
      packPluginPrice() {
        let price = 0;
        if(this.service && this.service.service_app_order.length>0) {
          let order = this.service.service_app_order
          order.forEach(item=>{
            price += item.subscribe_price * 10 / 11
          })
        }
        return price
      },
      buttonText() {
        let text = '다음'
        if(this.service.service_order.trial) text = '바로 결제'
        return text;
      },
      dateUnitText() {
        return this.order_product.date_unit + '개월'
      },
      vat() {
        return this.calcTotalPrice * 1 / 11;
      },
      totalPrice() {
        let price = this.memberShipPrice + this.hostingPrice + this.trialPrice;
        if(this.service && this.service.service_order.trial) {
          price += this.packPluginPrice;
        }
        return price;
      },
      calcTotalPrice() {
        return this.totalPrice + this.totalPrice / 10
      },
      memberShipPrice() {
        let price = 0;
        let option_id = this.order_product.order_product_option[0].option_id;
        let stock = find(this.selectorStocks, 'id', option_id);
        let option = find(this.order_product.product.selectors[0].options, 'id', stock.options[0]);
        if (this.order_product.date_unit === 1) {
          price = option.price * this.order_product.date_unit;
        } else {
          let subs = find(option.subscriptions, 'date_unit', this.order_product.date_unit);
          price = subs.price * this.order_product.date_unit;
        }
        return price;
      },
      hostingPrice() {
        let price = 0;
        if (this.hosting) price = this.hosting.price * this.order_product.date_unit;
        return price;
      },
      memberShip() {
        let option_id = this.order_product.order_product_option[0].option_id;
        return find(this.selectorStocks, 'id', option_id);
      },
      appPortingPrice() {
        let price = 0;
        if (this.order_product.date_unit === 3) {
          price = 780000
        } else if (this.order_product.date_unit > 3) {
          price = 550000
        }
        return price;
      },
      trialPrice() {
        let price = 0;
        if (this.trial_product.app_porting) price += this.appPortingPrice;
        return price;
      },
    },
    methods: {
      clickNext() {
        if (!this.service.service_order.trial) {
          this.$emit('updatePlan')
        } else {
          let admin = this.$store.getters.admin;
          let url = `${this.masterBackendUrl}serviceadmin/${admin.id}/` + `launchpack/service/${this.service.id}/plan_update`
          // let url = `http://localhost:8001/serviceadmin/${admin.id}/` + `launchpack/service/${this.service.id}/plan_update`
          let params = {
            order_id: this.service.service_order.id,
            update_date_unit: this.order_product.date_unit,
            option_id: this.order_product.order_product_option[0].option_id,
            trial_product: this.trial_product,
            price: this.calcTotalPrice
          }
          if(!this.enablePay) return;
          this.enablePay = false;
          this.$store.commit('setLoading', true);
          this.$axios.post(url, params).then(res => {
            if (res.status === 200) {
              this.enablePay = true;
              this.$store.commit('setLoading', false);
              this.$emit('next');
            }
          }).catch(error => {
            if (error.response.status > 400) {
              if(error.response.data.message)
                this.toast(error.response.data.message);
              else if(error.response.data.detail)
                this.toast(error.response.data.detail);
              else this.toast('서버에 오류가 발생했습니다. 관리자에게 문의주세요.');
              this.enablePay = true;
              this.$store.commit('setLoading', false);
            }
          })
          /*}).catch(()=>{

          })*/
        }
      },
      getPlanChangePayDay() {
        if (this.service.service_order.trial) this.payday = this.moment().format('YYYY.MM.DD')
        else if (this.service.status === 10) this.payday = this.moment().format('YYYY.MM.DD')
        else {
          let url = this.masterBackendUrl + 'public/launchpack/plan_change/pay_day'
          // let url = 'http://localhost:8001' + '/public/launchpack/plan_change/pay_day'
          let params = {
            order_id: this.service.service_order.id,
            update_date_unit: this.order_product.date_unit,
            option_id: this.order_product.order_product_option[0].option_id
          }
          this.$axios.post(url, params).then(res => {
            this.payday = res.data;
          })
        }
      }
    }
  }
</script>
<style lang="stylus" scoped>
  @import '~assets/css/lp_main'
  a
    color #08f

  .box-account
    margin-top 60px
    padding 16px 28px
    background-color $gray4
    border-radius 8px

  .box-account-mo
    margin-top 30px
    padding 16px
    background-color $gray4
    border-radius 8px

  .divider
    width 100%
    height 1px
    background-color $gray1
    margin 12px 0

  .divider-main
    width 100%
    height 1px
    background-color $main
    margin 12px 0

  .box-free
    background-color $sub2
    color white
    padding 20px 28px
    border-radius 8px
    display flex
    align-items center
    justify-content space-between
</style>
